import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from '../../helpers/propTypes';
import ErrorIcon from './icons/Error';
import MessagePage from './MessagePage';

function Error({ text, title, onButtonClick }) {
  return (
    <MessagePage
      buttonText={
        <FormattedMessage defaultMessage="Close" id="Error.CloseModal" />
      }
      icon={<ErrorIcon height="46" width="46" />}
      onButtonClick={onButtonClick}
      showButton={Boolean(onButtonClick)}
      text={text}
      title={title}
    />
  );
}

Error.propTypes = {
  onButtonClick: PropTypes.func.isRequired,
  text: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
};

export default Error;
